import React, { useState } from "react";
import PageTitle from "src/components/PageTitle";
import { useTranslation } from "src/context/Translations/context";
import { useLocation, useParams } from "react-router-dom";
import getUrlSearchParams from "src/utils/getUrlSearchParams";
import { RCCAlert } from "react-common-components";
import HierarchyFinancialManagementSubsidiary from "../components/HierarchySubsidiary";

const Subsidiary: React.FC = () => {
	const params = useParams<{
	    budgetPlanId: string;
	}>();
	
	const { translate } = useTranslation();
	
	const query = useLocation();
	const objQueryParams = getUrlSearchParams(query.search);

	const [budgetPlanTitle] = useState(objQueryParams?.name || "");
	const [titlePage] = useState(`${translate("Unidade/Filial")} - ${budgetPlanTitle}`);


	return (
		<>

			{/* Header -> Results + Buttons */}
			<PageTitle
				title={titlePage}
				icon={{
					name: "building"
				}}
			/>
			{params.budgetPlanId && params.budgetPlanId.length > 0 ? (
				<HierarchyFinancialManagementSubsidiary 
					ofa001Id={Number(params.budgetPlanId)}
					title={translate("Unidade/Filial")}
				/>
			): (
				<RCCAlert 
					title={translate("Atenção")}
					description={translate("Nenhum plano orçamentário selecionado")}
				/>
			)}
		</>
	);
};

export default Subsidiary;
